var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrivialLogoMainColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1010 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #41aaa5;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 5,
    y1: 100,
    x2: 131.55,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6bc9ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41aaa5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.61,19.7H35.94c-17.01,0-30.94,13.92-30.94,30.94v11.77c4.76-4.4,10.34-8.13,16.52-11,0,.61.18,1.28.57,2l9.01,16.23c.3.62,5.4,8.07,6.22,8.45,1.1.51,10.39-1.55,11.38-2.06,5.73-2.82-2.7-9.39.31-9.93,3.07-.51,6.39.06,9.97,1.71,3.3,1.53,5.84,3.75,7.62,6.66,1.78,2.92,2.17,5.47,1.15,7.66-1.16,2.52-2.79,4.22-4.87,5.11-2.08.89-5.11,1.3-9.08,1.23-5.19-.15-10.48.88-15.88,3.09-5.4,2.21-9.13,5.53-11.18,9.97l-1.66,3.58c-.43.93-.47,1.83-.13,2.72.34.88,1,1.55,1.96,1.99l19.79,9.16c.96.44,1.89.51,2.78.2.89-.31,1.56-.93,1.99-1.86.58-1.26,2.08-2.56,4.49-3.89,2.41-1.34,5.04-2.11,7.89-2.32,2.75-.18,4.87-.34,6.36-.5,1.49-.16,3.61-.58,6.35-1.29,2.74-.7,5.01-1.58,6.8-2.65,1.79-1.06,3.67-2.62,5.67-4.68,1.99-2.06,3.66-4.54,5.02-7.45,2.7-5.83,3.29-12.12,1.78-18.85-1.52-6.74-4.5-12.78-8.94-18.14-2.14-2.57-4.45-4.84-6.94-6.82,20.85,9.05,35.21,27.7,35.21,49.15,0,16.11-8.21,31.35-22.39,41.87-.25.21-.5.64-.5,1.07s.25.86.75,1.08l18.66,11.17h-60.2c-6.05,0-11.9-.73-17.45-2.1,4.78-3.34,7.91-8.87,7.91-15.14,0-10.2-8.27-18.46-18.46-18.46s-18.35,8.16-18.46,18.26c0,0,0,0,0,0v11.74c0,17.01,13.92,30.94,30.94,30.94h64.68c17.01,0,30.94-13.92,30.94-30.94V50.63c0-17.01-13.92-30.94-30.94-30.94Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M270.08,64.38h-34.06v92.35h-27.35v-92.35h-33.43v-21.12h94.85v21.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M358.85,116.6h-14.81v40.14h-27.35V43.26h44.66c13.46,0,23.98,2.98,31.56,8.95,7.59,5.97,11.38,14.4,11.38,25.3,0,7.89-1.6,14.43-4.79,19.62-3.2,5.19-8.2,9.39-15,12.61l23.69,45.82v1.17h-29.3l-20.03-40.14ZM344.04,95.56h17.3c5.19,0,9.1-1.37,11.73-4.1,2.62-2.73,3.94-6.55,3.94-11.45s-1.32-8.74-3.97-11.52c-2.65-2.79-6.55-4.18-11.69-4.18h-17.3v31.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M489.7,156.74h-27.28V43.26h27.28v113.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M592.5,125.87l22.6-82.61h30.55l-38.19,113.47h-29.93l-37.88-113.47h30.32l22.52,82.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M722.8,156.74h-27.28V43.26h27.28v113.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M846.01,135.54h-37.49l-6.55,21.2h-29.23l41.62-113.47h25.72l41.93,113.47h-29.38l-6.62-21.2ZM815.08,114.42h24.39l-12.24-39.36-12.16,39.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M957.38,135.69h47.62v21.04h-74.97V43.26h27.36v92.43Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrivialLogoMainColor);
export default __webpack_public_path__ + "static/media/trivial-logo-main-color.da821174dc0e6a5c357fab1aded89146.svg";
export { ForwardRef as ReactComponent };